/**
 * Mode coquille — production en build prod, demo (badge DEV seulement) en local.
 * @returns {'production'|'demo'}
 */
export function resolveKarateShellMode() {
  if (import.meta.env.VITE_KARATE_SHELL_MODE === "production") return "production";
  if (import.meta.env.VITE_KARATE_SHELL_MODE === "demo") return "demo";
  return import.meta.env.PROD ? "production" : "demo";
}
